import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Grid, Card, CardHeader, CardContent, Paper, Select, MenuItem, Chip, TextField, IconButton, Box, InputAdornment, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useParams } from 'react-router-dom';
import { Round, ROUND_STATUS, updateCurrentRound, updateCurrentRoundSolve, updatePlayerRoundSolve } from '../../components/utils/MatchUtils';
import { useMatch } from '../../hooks/useMatch';
import { db } from '../../config/firebase';
import MatchPlayer from '../../components/MatchPlayer';
import TwistyPlayerComponent from '../../components/TwistyPlayerComponent';
import MatchAdminPlayer from '../../components/MatchAdminPlayer';
import { putData } from '../../components/utils/PutData';
import { formatTime } from '../../hooks/useSolve';

const MatchAdmin = () => {
    const { id } = useParams();
    const { match, loading, error } = useMatch(db, id);
    const [currentScramble, setCurrentScramble] = useState<number>(0);
    
    const incrementSolveNumber = (event: React.MouseEvent<HTMLButtonElement>) => {
        updateCurrentRoundSolve(id!, match?.currentRound as number, match?.currentSolve as number + 1)
        match?.streamids.forEach(streamid=>{
            putData(`https://datastream.singular.live/datastreams/${streamid}`, { time: formatTime(0), official: true })
        })
    };

    const incrementRoundNumber = (event: React.MouseEvent<HTMLButtonElement>) => {
        updateCurrentRoundSolve(id!, match?.currentRound as number + 1, 0)
        match?.streamids.forEach(streamid=>{
            putData(`https://datastream.singular.live/datastreams/${streamid}`, { time: formatTime(0), official: true })
        })
    };

    const decrementRoundNumber = (event: React.MouseEvent<HTMLButtonElement>) => {
        updateCurrentRound(id!, match?.currentRound as number - 1)
        match?.streamids.forEach(streamid=>{
            putData(`https://datastream.singular.live/datastreams/${streamid}`, { time: formatTime(0), official: true })
        })
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                {/* Header */}
                <AppBar position="static" color='secondary'>
                    <Toolbar>
                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                            Match {id}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {/* Main Content */}
                {!loading && match !== null && <Grid container spacing={2} sx={{ padding: 2, flexGrow: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
                    {/* Player Overview */}
                    {match.uids && match.uids.map((p) => {
                        return <Grid key={p} item xs={6}>
                            <MatchAdminPlayer
                                playerId={p}
                                matchId={id!}
                                rounds={match.rounds ? match.rounds : []}
                                roundNumber={match.currentRound}
                                solveNumber={match.currentSolve}
                            />
                        </Grid>
                    })}

                    {/* Scramble Reveal Panel
                <Grid item xs={12}>
                    <Paper sx={{ padding: 2 }}>
                        <Typography variant="h6">Current Scramble</Typography>
                        <TextField
                            label="Scramble"
                            value={match.rounds !== undefined && match.currentRound !== -1 ? match.rounds[match.currentRound].scrambles[currentScramble] : ""}
                            fullWidth
                            InputProps={{ readOnly: true }}
                            variant="outlined"
                            sx={{ mt: 2 }}
                        />
                        <TwistyPlayerComponent 
                            width={"400px"}
                            height={"400px"}
                            alg={match.rounds !== undefined && match.currentRound !== -1 ? match.rounds[match.currentRound].scrambles[currentScramble] : ""}
                        />
                    </Paper>
                </Grid> */}
                </Grid>}

                {/* Bottom Action Bar (optional) */}
                {!loading && match !== null && <Paper elevation={3} sx={{ padding: 2, position: 'sticky', bottom: 0 }}>
                    <Button variant="contained" color="primary" onClick={incrementSolveNumber} sx={{ mr: 2 }}>
                        Next Solve
                    </Button>
                    <Button variant="contained" color="secondary" onClick={decrementRoundNumber} disabled={match.currentRound < 0} sx={{ mr: 2 }}>
                        Previous Round
                    </Button>
                    <Button variant="contained" color="secondary" onClick={incrementRoundNumber} disabled={match.currentRound > 3} sx={{ mr: 2 }}>
                        Next Round
                    </Button>

                    {/* Additional actions like Ending Match */}
                </Paper>}
            </div>
        </>
    );
}

export default MatchAdmin;
